export default __webpack_public_path__ + "static/media/SVGPrivacy.437532bc.svg";